export default {
    fields: {
        name: {
            label: 'Имя и фамилия',
            placeholder: 'Введите имя и фамилию',
        },
        email: {
            label: 'Email',
            placeholder: 'Введите email',
        },
        phone: {
            label: 'Телефон',
            placeholder: 'Введите телефон',
        },
        company: {
            label: 'Компания',
            placeholder: 'Введите название компании',
        },
        description: {
            label: 'Сообщение',
            placeholder: 'Введите сообщение',
        },
        title: {
            label: 'Заголовок',
            placeholder: 'Введите заголовок',
        },
    },
    buttons: {
        send: 'Отправить',
    },
    success: {
        message: 'Ваш вопрос отправлен. Вы получите ответ в ближайшее время!',
    },
}
